/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface Props {
  avatarEntity?: any;
  accept: (...args: Array<any>) => any;
  reject: (...args: Array<any>) => any;
  collapsed: boolean;
  children: React.ReactNode;
}

class OrganizationRequest extends React.Component<Props> {
  static defaultProps = {
    collapsed: false,
  };

  renderButtons = (): React.ReactNode => [
    <Button
      buttonStyle={ButtonStyle.PRIMARY}
      size={ButtonSize.SMALL}
      key="accept"
      onClick={this.props.accept}
      text="Accept"
      dataTestAttrs={{component: 'OrganizationRequest', element: 'acceptButton'}}
    />,
    ' ',
    <Button
      buttonStyle={ButtonStyle.NEGATIVE}
      size={ButtonSize.SMALL}
      key="reject"
      className="u-tiny-spacing-left"
      onClick={this.props.reject}
      text="Reject"
    />,
  ];

  override render(): JSX.Element {
    return (
      <div
        className="organizationInvitesSection-inviteCard"
        {...getTestProps({component: 'OrganizationRequest', element: 'root'})}
      >
        <div className="u-overflow-hidden u-small-spacing-bottom">{this.props.children}</div>
        <div>{this.renderButtons()}</div>
      </div>
    );
  }
}

export default OrganizationRequest;
